import { 
  Grid, 
  GridCell, 
  GridCellProps, 
  GridColumn
} from '@progress/kendo-react-grid';
import React from 'react';
import Component from '../../../../../dispatcher/modules/component/Component';
import { 
  ACTIVE_SESSIONS_PROPS,
  ACTIVE_SESSIONS_STATE
} from './Types';

class ActiveSessions extends Component<ACTIVE_SESSIONS_PROPS, ACTIVE_SESSIONS_STATE> {
  static defaultProps = {
    sessionsData: {}
  };
  public state: ACTIVE_SESSIONS_STATE = {};

  /**
   * Login time column renderer.
   * Format timestamp to string based on format from localisation.
   */
  loginTimeColumnRender = (cellProps: GridCellProps) => {
    const { dataItem, field } = cellProps;
    let loginTime = null;
    if (field) {
      loginTime = this.translate('sessionLoginDate', {
        date: new Date(dataItem[field])
      });
    }
    return <GridCell {...cellProps}>{loginTime}</GridCell>;
  };

  /**
   * Location column renderer.
   */
  locationColumnRender = (cellProps: GridCellProps) => {
    const { dataItem, field } = cellProps;
    let location = null;
    if (field) {
      location = dataItem[field];
    }

    return (
      dataItem.currentUserSession ? (
        <GridCell {...cellProps}>
          {location}
          <span className={'tp-font-italic'}>
            ({this.translate('Activity from current sessions')})
          </span>
        </GridCell>
      ) : (
        <GridCell {...cellProps}>
          {location}
        </GridCell>
      )
    );
  };

  getColumnConfiguration() {
    return [{
      field: 'userAgent',
      key: 'userAgent',
      title: this.translate('accessInformation')
    }, {
      field: 'ipAddress',
      key: 'ipAddress',
      title: this.translate('locations'),
      cell: this.locationColumnRender
    }, {
      field: 'loginTime',
      key: 'loginTime',
      title: this.translate('loginDate'),
      cell: this.loginTimeColumnRender
    }];
  }

  renderBody() {
    const { sessionsData } = this.props;
    const columns = this.getColumnConfiguration();
    return (
      <Grid
        className={'tp-no-border tp-active-session-grid'}
        data={sessionsData.userSessions}
      >
        {columns.map(column => (
          <GridColumn {...column} />
        ))}
      </Grid>
    );
  }
}

export default ActiveSessions;
